import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VersionsService } from '@osapp/modules/versions/services/versions.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  private remoteVersionUrl = `${environment.urlWebApp}/assets/app-version.json`;

  constructor(
		private http: HttpClient,
		private svcVersion:VersionsService
	) {}

  checkVersion(onUpdateAvailable: (remoteVersion: string) => void): void {
		const localVersion = this.svcVersion.version

    const remote$ = this.http.get<{ version: string }>(this.remoteVersionUrl).pipe(
			catchError(err => {
				console.error('Erreur lors de la récupération de la version distante', err);
				return of({ version: '0.0.0' });
			})
  	);

		// Pour tester on fausse la version webapp
		// const remote$ = of({ version: '5.13.16' });


		remote$.subscribe(remote => {
			if (this.isVersionNewer(remote.version, localVersion)) {
				console.warn(`Nouvelle version disponible : ${remote.version}`);
				onUpdateAvailable(remote.version);
			} else {
				console.warn('L’application est à jour.');
			}
		});
  }

  private isVersionNewer(remote: string, local: string): boolean {
    const r = remote.split('.').map(Number);
    const l = local.split('.').map(Number);
    for (let i = 0; i < Math.max(r.length, l.length); i++) {
      const rVal = r[i] || 0;
      const lVal = l[i] || 0;
      if (rVal > lVal) return true;
      if (rVal < lVal) return false;
    }
    return false;
  }
}
